import CheckboxRadioContainer from "../../Componant/FormControl/CheckboxRadio";

const CheckboxRadio = () => {
  return (
    <div className="page-body">
      <CheckboxRadioContainer />
    </div>
  );
};

export default CheckboxRadio;
